import type { UIMessage } from "@convex-dev/agent";

/** A `useUIMessages` row; the app's api only types the paging shape. */
type UIMessageRow = Pick<UIMessage, "role" | "parts">;

/** The full UI message the messenger queries return, checked instead of cast. */
export function isFullUIMessage<T extends UIMessageRow>(
  row: T,
): row is T & UIMessage {
  const full: Partial<UIMessage> = row;
  return (
    typeof full.key === "string" &&
    typeof full.text === "string" &&
    typeof full._creationTime === "number"
  );
}
